import { useCallback, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import _debounce from 'lodash/debounce';
import { emitCustomEvent } from 'react-custom-events';

export default function BasicTextField({
    onFieldChange,
    value,
    setValue,
    field,
    label,
    styleOverride,
    variant,
    placeholder,
    attributeFormatOverride,
    useFullWidth,
    helperText,
    isError = false,
    useMultiline = false,
    isDisabled = false,
    inputProps = null,
    triggerEvent = null,
    index = null,
}) {
    const [localValue, setLocalValue] = useState('');

    const handleTextChange = (event, targetValue, prevValue) => {
        if (prevValue !== targetValue) {
            setValue(targetValue);
            if (triggerEvent) {
                if (attributeFormatOverride) {
                    const valueOverride = attributeFormatOverride(field, targetValue);
                    emitCustomEvent(triggerEvent, { field: field, value: valueOverride });
                } else {
                    if (index !== null) {
                        emitCustomEvent(triggerEvent, {
                            field: index,
                            value: targetValue,
                            index: index,
                        });
                    } else {
                        emitCustomEvent(triggerEvent, { field: field, value: targetValue });
                    }
                }
            }
        }
    };

    const debounceTextFn = useCallback(_debounce(handleTextChange, 200), []);

    useEffect(() => {
        if (value !== localValue) {
            if (value) {
                setLocalValue(value);
            } else if (!value) {
                setLocalValue('');
            }
        }
    }, [value]);

    return (
        <TextField
            label={label}
            key={field}
            multiline={useMultiline}
            style={styleOverride ? styleOverride : { minWidth: 240, marginTop: 10 }}
            value={localValue}
            onChange={(event) => {
                setLocalValue(event.target.value);
                debounceTextFn(event, event.target.value, value);
            }}
            disabled={isDisabled}
            fullWidth={useFullWidth}
            variant={variant ? variant : 'standard'}
            placeholder={placeholder ? placeholder : ''}
            error={isError}
            helperText={helperText}
            {...inputProps}
        />
    );
}
